import DashboardHome from "@/components/Dashboard/Home";
import EquipmentHome from "@/components/Equipment/Index";
import NewEquipment from "@/components/Equipment/NewEquipment";
import NewCrop from "@/components/CropManager/NewCrop";
import NewCropType from "@/components/CropManager/NewCropType";
import NewCropTradeName from "@/components/CropManager/NewCropTradeName";
import ViewCrop from "@/components/CropManager/ViewCrop";
import Equipment from "@/components/Equipment/Equipment";
import EquipmentTypes from "@/components/Equipment/EquipmentTypes";
import EquipmentRequests from "@/components/EquipmentRequests/Home";
import CropManagerHome from "@/components/CropManager/Index";
import CropManager from "@/components/CropManager/Home";
import SoilTestingHome from "@/components/SoilTests/Index";
import SoilTesting from "@/components/SoilTests/Home";
// import SoilTesting from "@/components/CropManager/Home";
import ShopHome from "@/components/Shop/Index";
import ShopProducts from "@/components/Shop/Home";
import ShopOrders from "@/components/Shop/Orders";
import NewProduct from "@/components/Shop/NewProduct";

import ProvincialManagersHome from "@/components/ProvincialManagers/Index";
import ProvincialManagers from "@/components/ProvincialManagers/ProvincialManagers";
import NewProvincialManager from "@/components/ProvincialManagers/NewProvincialManager";
import UsersHome from "@/components/Users/Index";
import Users from "@/components/Users/AllUsers";
import SoilTestsResults from "../components/SoilTests/TestResults.vue";

import FarmAssessments from "../components/FarmAssessments/AllFarmAssessments.vue"
import FarmAssessmentHome from "../components/FarmAssessments/Home.vue"

export default [
  {
    path: "/",
    name: "Dashboard",
    component: DashboardHome,
    children: []
  },
  {
    path: "/equipment-requests",
    name: "Equipment Requests",
    component: EquipmentRequests
  },
  {
    path: "/crop-manager",
    name: "Crop Manager",
    component: CropManagerHome,
    children: [
      {
        path: "",
        name: "Crop Manager",
        component: CropManager
      },
      {
        path: "new-crop",
        name: "Add New Crop",
        component: NewCrop
      },
      {
        path: "new-crop-type",
        name: "Add Crop Type",
        component: NewCropType
      },
      {
        path: "new-crop",
        name: "Add Crop Trade Name",
        component: NewCropTradeName
      },
      {
        path: "view-tips",
        name: "View Crop Tips",
        component: ViewCrop
      }
    ]
  },
  {
    path: "/soil-Test",
    name: "Soil Tests",
    component: SoilTestingHome,
    children: [
      {
        path: "",
        name: "Soil Tests",
        component: SoilTesting
      },
      {
        path: "soil-test-results",
        name: "Soil Tests Results",
        component: SoilTestsResults
      }
    ]
  },

  {
    path: "/equipment",
    name: "Equipment",
    component: EquipmentHome,
    children: [
      {
        path: "",
        name: "Equipment",
        component: Equipment
      },
      {
        path: "new",
        name: "Add New Equipment",
        component: NewEquipment
      },
      {
        path: "types",
        name: "Equipment Types",
        component: EquipmentTypes
      }
    ]
  },
  {
    path: "/provincial-managers",
    name: "Provincial Managers",
    component: ProvincialManagersHome,
    children: [
      {
        path: "",
        name: "Provincial Managers",
        component: ProvincialManagers
      },
      {
        path: "new",
        name: "Add New Provincial Manager",
        component: NewProvincialManager
      }
    ]
  },
  {
    path: "/users",
    name: "Users",
    component: UsersHome,
    children: [
      {
        path: "",
        name: "Users",
        component: Users
      }
    ]
  },
  {
    path: "/farmassessment",
    name: "Farm Assessment",
    component: FarmAssessmentHome,
    children: [
      {
        path: "",
        name: "Farm Assessments",
        component: FarmAssessments
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/admin.js